import React, { useState, useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
    Row, Col, ButtonGroup, Button, ButtonDropdown,
    DropdownToggle, DropdownMenu, DropdownItem,
    Card, CardBody, CardTitle, CardText
} from 'reactstrap';
import { Form, FormGroup, Label } from 'reactstrap';
import { reduxForm } from 'redux-form'
import { BricksForm, Loader, FormsField, ActivitiesField, UsersField, EmailLayoutsField, WysiwygField, TranslatableField } from '../../../components';
import { updateWorkflow, getWorkflowsLinkedResources } from '../../../redux';
import { Brick } from '../../../models';

import moment from 'moment';
import 'moment/locale/fr';
import momentLocalizer from 'react-widgets-moment';
import 'react-widgets/dist/css/react-widgets.css';

moment.locale('fr');
momentLocalizer();

let WorkflowForm = (props) => {
    const { isCreation, handleSubmit, pristine, submitting } = props;
    const [isOpen, setIsOpen] = useState(false);

    const { t }    = useTranslation();
    const dispatch = useDispatch();

    const { isLoading, workflow } = useSelector(state => state.workflows);

    const updateBrickOrder = (bricks) => {
        dispatch(updateWorkflow({ ...workflow, bricks }));
    }

    const addBrick = type => {
        dispatch(updateWorkflow({
            ...workflow,
            bricks: [
                ...workflow.bricks,
                Brick.make({ type })
            ]
        }));
    }

    const remove = (position) => {
        dispatch(updateWorkflow({
            ...workflow,
            bricks: workflow.bricks.filter(b => b.position !== position)
        }));
    }

    useEffect(() => {
        dispatch(getWorkflowsLinkedResources());
    }, [])

    const brickTypes = Brick.getBrickTypes()
        .sort((a, b) => t(`workflows.bricks.${a}.type_title`).localeCompare(t(`workflows.bricks.${b}.type_title`)))
        .map(type => [type, t(`workflows.bricks.${type}.type_title`)]);

    return (
        <Form onSubmit={handleSubmit}>
            <Row>
                <Col>
                    <Card>
                        <CardBody>
                            <CardTitle><i className="fa fa-info-circle"></i>&nbsp;{t("workflows.informations")}</CardTitle>
                            <CardText tag="div">
                                <Row>
                                    <Col>
                                        <FormGroup row>
                                            <Label for="name" sm={12}>{t("workflows.name")}</Label>
                                            <Col sm={12}>
                                                <TranslatableField name="name" placeholder={t("workflows.name_placeholder")} component="input" />
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                    <Col>
                                        <FormGroup row>
                                            <Label for="description" sm={12}>{t("workflows.description")}</Label>
                                            <Col sm={12}>
                                                <TranslatableField name="description" placeholder={t("workflows.description_placeholder")} component={WysiwygField} />
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardText>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            { !isCreation && (
                <Row>
                    <Col>
                        <Card>
                            <CardBody>
                                <CardTitle><i className="fa fa-dot-circle-o"></i>&nbsp;{t("workflows.bricks.title")}</CardTitle>
                                <CardText tag="div">
                                    <BricksForm
                                        workflow={ workflow }
                                        updateBrickOrder={ updateBrickOrder}
                                        remove={ remove }
                                />
                                </CardText>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            )}
            <br/>
                <Row>
                    <Col className="text-center">
                        <ButtonDropdown isOpen={isOpen} toggle={() => setIsOpen(!isOpen)}>
                            <DropdownToggle caret color="primary">
                                { t('workflows.add_brick') }
                            </DropdownToggle>
                            <DropdownMenu right>
                                {brickTypes.map(([type, label]) => (
                                    <DropdownItem key={ type } onClick={() => addBrick(type)}>
                                        { label }
                                    </DropdownItem>
                                ))}
                            </DropdownMenu>
                        </ButtonDropdown>
                        <Button type="submit" color="success" disabled={pristine || submitting || isLoading}>
                            {isLoading ?
                                <span>
                                    &nbsp;<i className="fa fa-spinner fa-spin"></i>
                                </span>
                                :
                                <span>
                                    <i className="fa fa-save"></i>&nbsp;
                                    {t("common.save")}
                                </span>
                            }
                        </Button>
                    </Col>
                </Row>
        </Form>
    );

}

WorkflowForm = reduxForm({
  form: 'workflowForm',
  enableReinitialize: true
})(WorkflowForm);

WorkflowForm = connect(
  state => ({
    initialValues: state.workflows.workflow,
    Workflows: state.workflows,
}), {}
)(WorkflowForm)

export default WorkflowForm;
